import classnames from 'classnames'
import * as React from 'react'

import { Button, Icon } from '../../components'
import { usePrevious } from '../../hooks/use-previous'

interface Props {
  showMoreLabel: string
  showLessLabel: string
  isShowMore: boolean
  hasHiddenRows: boolean
  onShowMoreToggle: (isShowMore: boolean) => void
}

// Rating relevancy is going to be done in some follow up
const TEMP_HIDDEN_RATE_RELEVANCY = true

export function TrafficTableBottomContent({
  showMoreLabel,
  showLessLabel,
  isShowMore,
  hasHiddenRows,
  onShowMoreToggle,
}: Props) {
  const wrapperRef = React.useRef<HTMLDivElement>(null)
  const previousExpandWrapperTopRef = React.useRef(0)
  const isShowMorePrevious = usePrevious(isShowMore)

  React.useEffect(() => {
    if (isShowMorePrevious && !isShowMore) {
      setTimeout(() => {
        const currentExpandWrapperTop = wrapperRef.current?.getBoundingClientRect().top ?? 0
        window.scrollTo({ top: window.scrollY - (previousExpandWrapperTopRef.current - currentExpandWrapperTop) })
      })
    }
  }, [isShowMorePrevious, isShowMore])

  return (
    <div className="flex w-full items-center justify-between" ref={wrapperRef}>
      {hasHiddenRows ? (
        <Button
          theme="link"
          type="button"
          size="small"
          onClick={() => {
            previousExpandWrapperTopRef.current = wrapperRef.current?.getBoundingClientRect().top ?? 0
            onShowMoreToggle(!isShowMore)
          }}
          leftContent={<Icon name="chevronDown" width={12} className={classnames({ 'rotate-180': isShowMore })} />}
          className="font-normal"
        >
          {isShowMore ? showLessLabel : showMoreLabel}
        </Button>
      ) : (
        <div />
      )}

      <div className="flex flex-none items-center font-sans text-2xs">
        <span className="text-muted-2">Data source: similarweb.com</span>
        {!TEMP_HIDDEN_RATE_RELEVANCY && (
          <>
            <span className="pl-1.5 text-muted-2">•</span>
            <Button theme="link" as="a" href="#" size="small" className="font-normal">
              Rate Domains Relevancy
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
